import React, { use, useEffect, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import ajaxConfig from '../../util/remote/ajaxConfig';
import { useAccounts } from '../../DataStore/AccountsContext';
import { useConfig } from '../../DataStore/ConfigContext';
import { useTheme } from '../../DataStore/ThemeContext';



const ConfigSpecialAccount = ({specialAccount}) => {
    const {liabilityAccountListing, getLiabilityAccounts,  assetAccountListing, getAssetAccounts,} = useAccounts();
    const {getSpecialAccounts} = useConfig();

    const [info, setInfo] = useState(null);
    const [value, setValue] = useState("0");
    const [loading, setLoading] = useState(false);
    const {setSystemFunction} = useTheme();

    useEffect(()=>{
        getLiabilityAccounts();
        getAssetAccounts();
    }, []);



    useEffect(()=>{
        setSystemFunction(() => handleConfirm);
        return () => setSystemFunction(() => {});
    }, [value]);

    const handleConfirm = async () =>{
       
        if(value.length === 0){
            setInfo(<Notification type='danger' message="Enter configuration value please"/>);
            return;
        }
        setLoading(true);
        const server_response = await ajaxConfig.setSpecialAccount(specialAccount.id, value);
        setLoading(false);
        if(server_response.status==="OK"){
            setInfo(<Notification type='success' message={server_response.message} closable={false}/>);
            await getSpecialAccounts(true);
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }


    const RenderLiabilityAccount = () => {

        
            const options=[];
            if(Array.isArray(liabilityAccountListing))
            {
                liabilityAccountListing.map((item, key)=>
                    options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
                )
            }
            return(
                <TextInput
                    type="select"
                    label="Liability Account"
                    placeholder="Select Account"
                    leftIcon="fa fa-bank"
                    options={options}
                    onChange={item => setValue(item.value)}
                    leftComponent={<i className="fa fa-bank link" onClick={()=>getLiabilityAccounts(true)}></i>}
                    loading={!liabilityAccountListing}
                    required
                    wrap
                    value={value}
            />
    
            )
      }
    

      const RenderAssetAccount = () => {

        
        const options=[];
        if(Array.isArray(assetAccountListing))
        {
            assetAccountListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }
        return(
            <TextInput
                type="select"
                label="Asset Account"
                placeholder="Select Account"
                leftIcon="fa fa-bank"
                options={options}
                onChange={item => setValue(item.value)}
                leftComponent={<i className="fa fa-bank link" onClick={()=>getAssetAccounts(true)}></i>}
                loading={!liabilityAccountListing}
                required
                wrap
                value={value}
        />

        )
  }


    return (
        <>

            <CallOut 
                title={specialAccount.designation}
                description={specialAccount.description}
             />
            <div className="mb-4 mt-4 animate__animated animate__fadeIn">{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                {specialAccount.account_type * 1 === 4 && RenderLiabilityAccount()}
                {specialAccount.account_type * 1 === 3 && RenderAssetAccount()}

                        

            </form> 

        </>
    );
};

export default ConfigSpecialAccount;